/** Важно!
 * Это не @templates , которые находятся внутри модели Event.
 * Это отдельная сущность, которая пока что создается только
 * в кабинете администратора!
 */
import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';

import AdminEventTemplateData from './admin-event-template-data';
import BaseModel from './base';
import AdminEventTemplateTag from './admin-event-template-tag';

export const TEMPLATE_STATUS = {
  hide: 1,
  open: 2,
};

export default class AdminEventTemplate extends BaseModel {
  constructor(template, url) {
    super(template, url);
    this.description = template.description;
    this.created_at = template.created_at;
    this.updated_at = template.updated_at;

    this.status = template.status || TEMPLATE_STATUS.hide;
    this.image = template.image || null;
    this.data = new AdminEventTemplateData(template.data || {});

    this.tags = (template.tags || []).map((item) => new AdminEventTemplateTag(item));

    // По факту (на беке) у нас много групп можно привязать,
    // но сейчас мы ограничиваем функционал, что на один шаблон одна группа
    this.groups = (template.groups || []).map((item) => new AdminEventTemplateTag(item));
  }

  get statusData() {
    return {
      [TEMPLATE_STATUS.hide]: {
        text: 'Черновик',
      },
      [TEMPLATE_STATUS.open]: {
        text: 'Активный шаблон',
      },
    }[this.status];
  }

  get isOpen() {
    return this.status === TEMPLATE_STATUS.open;
  }

  createEvent() {
    return rHandler(
      apiService.post(`${this.url}/${this.id}/create-event`),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }

  #setStatusOpen() {
    return rHandler(
      apiService.post(`${this.url}/${this.id}/open`),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }

  #setStatusHide() {
    return rHandler(
      apiService.post(`${this.url}/${this.id}/hide`),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }

  async switchStatus() {
    const statusChangeData = {
      [TEMPLATE_STATUS.hide]: {
        method: () => this.#setStatusOpen(),
      },
      [TEMPLATE_STATUS.open]: {
        method: () => this.#setStatusHide(),
      },
    }[this.status];
    const { response, error } = await statusChangeData.method();
    if (!error) {
      this.status = response.data.data.status;
    }
    return { response, error };
  }
}
